import { render } from "./TagEditData.vue?vue&type=template&id=14219154"
import script from "./TagEditData.vue?vue&type=script&lang=js"
export * from "./TagEditData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__